// extracted by mini-css-extract-plugin
export var productImage = "_mv-1";
export var viewLink = "_mv-2";
export var wishlistItem = "_mv-0";